var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrap"},[_c('section',{staticClass:"auth-wrap-section"},[_vm._t("content")],2),_vm._v(" "),_c('section',{staticClass:"auth-wrap-section image-wrap"},[_vm._t("image")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }